import { MakeCall } from './createMakeCall';

/** @swagger /#api-Default-userUserIdPayoutMethodPayoutMethodIdGet */
export default (makeCall: MakeCall) => (methodId: number) =>
  makeCall('GET', `/api/v2/user/me/payout-method/${methodId}`);
